import { useEffect } from 'react';
import _ from 'lodash';
import { KEY_RECOIL } from '@/shared/config';
import {
  selectControlModal,
  selectSelectedColumnInfo,
  selectSelectedEventIndex,
  useReportStore,
} from '@/entities/report';

/**
 * Supplies the HR summary tab's modal layer with the control modal state, timezone and ECG data map. Reads the TAB_6 control modal and column selection from the report store and resets the modal whenever the selected event changes while the duration modal is open.
 *
 * @returns An object carrying controlModal, timezone and ecgDataMap.
 */
const useHRSummaryModal = () => {
  const keyRecoil = KEY_RECOIL.HR_SUMMARY;
  const controlModal = useReportStore(selectControlModal(keyRecoil));
  const resetControlModalAction = useReportStore((s) => s.actions.resetControlModal);
  /**
   * Clears the HR summary tab's control modal state back to its defaults. Forwards the TAB_6 key to the store's resetControlModal action.
   *
   * @returns Nothing.
   */
  const resetControlModal = () => resetControlModalAction(keyRecoil);
  const selectedColumnInfo = useReportStore(selectSelectedColumnInfo(keyRecoil));
  const selectedEventIndex = useReportStore(selectSelectedEventIndex(keyRecoil));

  const selectedEvent = _.isEmpty(selectedColumnInfo)
    ? null
    : selectedColumnInfo[selectedEventIndex];
  // reportInfoState (Recoil, Task 7) is typed {} | IReportInfo (atom default is {}) - pre-existing gap.
  const { timezone } = useReportStore((s) => s.reportInfo) as any;
  const ecgDataMap = useReportStore((s) => s.ecgDataMap);

  useEffect(() => {
    if (controlModal.isShowChangeDurationSelectedInfo) {
      resetControlModal();
    }
  }, [selectedEvent?.id]);

  return {
    controlModal,
    timezone,
    ecgDataMap,
  };
};

export default useHRSummaryModal;
